<template>
  <v-container fluid fill-height>
    <v-toolbar :color="toolbarColor" dark app fixed flat>
      <v-toolbar-title style="width: 300px;" class="ml-5 pl-3">
         <a :href="`${webUrl}`" target="_blank">
          <img src="@/assets/logo.png" style="width: 100px; height: 70px;" alt>
        </a>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark :color="toolbarColor">
            <v-toolbar-title>Expertise Update</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap>
              <expertise></expertise>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Expertise from "../_components/expertise.vue";
import { mapGetters } from 'vuex';
export default {
  name: "ExpertiseUpdatePage",
   computed: {
    ...mapGetters(["user"]),
     ...mapGetters(["webUrl"])
  },
  components: {
      Expertise
  },
  data() {
    return {
      expertColor: "white",
      toolbarColor: null,
      userAccount: null,
      accountType: null,
      otp: null,
      err_msg: null,
      loading: false
    };
  },
  methods: {

  },
  created() {
    const account = this.$route.params.status;
    this.userAccount = account;
    if (account == "expert") {
      this.accountType = "Fundi";
      this.toolbarColor = "blue darken-1";
    } else {
      this.accountType = "Sonko";
      this.toolbarColor = "green darken-1";
    }
  }
};
</script>



